import React from 'react';

import { StripeV2SubscriptionPrice } from '@/services/stripe/dto';

import { DefaultDescription } from './DefaultDescription';
import { MonthlyDescription } from './MonthlyDescription';
import { ThreeMonthsDescription } from './ThreeMonthsDescription';
import { YearlyDescription } from './YearlyDescription';

export const SimplePaymentDescription: React.FC<{
  selectedPlan: StripeV2SubscriptionPrice | undefined | null;
  monthlyPlan: StripeV2SubscriptionPrice | undefined | null;
}> = ({ selectedPlan }) => {
  if (!selectedPlan) {
    return <DefaultDescription />;
  }

  switch (selectedPlan.id) {
    case 'pro.1y':
      return <YearlyDescription selectedPlan={selectedPlan} />;
    case 'pro.1m':
    case 'pro.rebill_1m_discount':
    case 'pro.rebill_month_29_99':
    case 'pro.rebill_month_29_99_to_39_99':
    case 'pro.rebill_month_49_99':
    case 'pro.rebill_2weeks_39_99':
      return <MonthlyDescription selectedPlan={selectedPlan} />;
    case 'pro.3m':
    case 'pro.rebill_3m_discount':
    case 'pro.rebill_3months_59_99':
    case 'pro.rebill_3months_59_99_to_79_99':
      return <ThreeMonthsDescription selectedPlan={selectedPlan} />;
    default:
      return <DefaultDescription />;
  }
};
